import { useState } from 'react';
import { Question } from '@amo/core/components/containers';
import info from '@amo/core/assets/images/AMO_Icons/Searching.svg';
import { getStepBySlug } from '../../../../../utils/function';
import RecapGPTVehicule from './RecapGPTVehicule';
import RecapGPTConducteur from './RecapGPTConducteur';
import RecapGPTAntecedents from './RecapGPTAntecedents';
import RecapGPTBesoins from './RecapGPTBesoins';
import RecapGPTConsent from './RecapGPTConsent';

const RecapGPT = (props) => {
    const {
        vehiculeData,
        vehiculeInfo,
        typeVehicule,
        personne,
        antecedents,
        devoirConseil,
        police,
        typeMER,
        gptConsent,
        goToStepForEdit,
        submitConsent,
        setStep,
    } = props;

    const [loading, setLoading] = useState(false);
    const [consentError, setConsentError] = useState(false);

    const handleContinue = async () => {
        if (!gptConsent) {
            setConsentError(true);
            return;
        }
        setConsentError(false);
        setLoading(true);
        try {
            await submitConsent();
        } catch (e) {
            // Le consent est best-effort, on continue quand même
        }
        setLoading(false);
        sessionStorage.setItem('gptRecapCompleted', 'true');
        setStep({ step: getStepBySlug('votre-tarif') });
    };

    return (
        <div id={'etape-recap-gpt'}>
            <Question icon={info} title={'Récapitulatif de vos informations'} full>
                <p className={'f-14 text-muted mb-4'}>
                    Voici les informations que vous avez communiquées via{' '}
                    {typeMER === 'AgentConv' ? "l'agent conversationnel" : "l'assistant ChatGPT"}.
                    Veuillez les vérifier avant de consulter votre tarif.
                </p>

                <RecapGPTVehicule vehiculeData={vehiculeData} vehiculeInfo={vehiculeInfo} typeVehicule={typeVehicule} onEdit={() => goToStepForEdit('votre-vehicule')} />
                <RecapGPTConducteur personne={personne} onEdit={() => goToStepForEdit('votre-profil')} />
                <RecapGPTAntecedents personne={personne} antecedents={antecedents} onEdit={() => goToStepForEdit('vos-antecedents')} />
                <RecapGPTBesoins devoirConseil={devoirConseil} police={police} onEdit={() => goToStepForEdit('vos-besoins')} />
                <RecapGPTConsent {...props} consentError={consentError} />
            </Question>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${!gptConsent || loading ? 'disabled' : ''}`}
                onClick={handleContinue}
                disabled={!gptConsent || loading}
            >
                {loading ? 'Envoi en cours…' : 'Continuer vers le tarif'}
            </button>
        </div>
    );
};

export default RecapGPT;
